import db from './indexDB'
import ForecastingTables from '@/repos/forecastingTables';
import momentCache from "@/services/momentCache"

export default {
    async getPlantData(plantId) {
        return await db[ForecastingTables.Plants]
            .where({ plantId })
            .toArray();
    },
    async putPlantData(plantData){
        await db[ForecastingTables.Plants].bulkPut(plantData);
    },
    async clearPlantData() {
        await db[ForecastingTables.Plants].clear();
    },
    async getFinancialYearCalendarsData() {
        return await db[ForecastingTables.FinancialYearCalendars]
            .toArray();
    },
    async putFinancialYearCalendarsData(financialYearCalendarsData){
        await db[ForecastingTables.FinancialYearCalendars].bulkPut(financialYearCalendarsData);
    },
    async clearFinancialYearCalendarsData() {
        await db[ForecastingTables.FinancialYearCalendars].clear();
    },
    async getWeatherData(plantId, startDate, endDate) {
        let items = await db[ForecastingTables.Weather]
            .where({ plantId })
            .toArray();

        return items.filter(x => 
            momentCache.getMoment(x.temperatureDate).isBetween(startDate, endDate, null, '[]')
        );
    },
    async putWeatherData(weatherData){
        await db[ForecastingTables.Weather].bulkPut(weatherData);
    },
    async clearWeatherData() {
        await db[ForecastingTables.Weather].clear();
    },
    async getCrops(plantId, productCategoryId) {
        return await db[ForecastingTables.Crops]
            .where({ plantId, productCategoryId })
            .toArray();
    },
    async putCrops(crops){
        await db[ForecastingTables.Crops].bulkPut(crops);
    },
    async clearCrops() {
        await db[ForecastingTables.Crops].clear();
    },
    async getNuPointSprays(locationIds, startDate, endDate) {
        let items = await db[ForecastingTables.NuPointSprays]
            .where("LocationID").anyOf(locationIds)
            .toArray();

        return items.filter(x => 
            momentCache.getMoment(x.NuPointSprayDate).isBetween(startDate, endDate, null, '[]')
        );
    },
    async putNuPointSprays(nuPointSprays){
        await db[ForecastingTables.NuPointSprays].bulkPut(nuPointSprays);
    },
    async clearNuPointSprays() {
        await db[ForecastingTables.NuPointSprays].clear();
    },
    async getVarieties(cropLocationIds) {
        return await db[ForecastingTables.Varieties]
            .where("cropLocationId").anyOf(cropLocationIds)
            .toArray();
    },
    async putVarieties(varieties){
        await db[ForecastingTables.Varieties].bulkPut(varieties);
    },
    async clearVarieties() {
        await db[ForecastingTables.Varieties].clear();
    },
    async getForecasts(cropLocationIds, startDate, endDate) {
        let items = await db[ForecastingTables.Forecasts]
            .where("cropLocationId").anyOf(cropLocationIds)
            .toArray();


        return items.filter(x => 
            momentCache.getMoment(x.forecastDate).isBetween(startDate, endDate, null, '[]')
        );
    },
    async getForecast(cropLocationId, varietyId, forecastDate) {
        return await db[ForecastingTables.Forecasts]
            .where({ cropLocationId, varietyId, forecastDate })
            .first();
    },
    async putForecasts(forecasts){
        await db[ForecastingTables.Forecasts].bulkPut(forecasts);
    },
    async putForecast(forecast){
        await db[ForecastingTables.Forecasts].put(forecast);
    },
    async clearForecasts() {
        await db[ForecastingTables.Forecasts].clear();
    },
    async countUnsentForecasts(){
        return await db[ForecastingTables.UnsentForecasts]
            .count();
    },
    async getAllUnsentForecasts(){
        return await db[ForecastingTables.UnsentForecasts]
            .toArray();
    },
    async getUnsentForecasts(cropLocationIds, startDate, endDate){
        let items = await db[ForecastingTables.UnsentForecasts]
            .where("cropLocationId").anyOf(cropLocationIds)
            .toArray();


        return items.filter(x => 
            momentCache.getMoment(x.forecastDate).isBetween(startDate, endDate, null, '[]')
        );
    },
    async getUnsentForecast(cropLocationId, varietyId, forecastDate) {
        return await db[ForecastingTables.UnsentForecasts]
            .where({ cropLocationId, varietyId, forecastDate })
            .first();
    },
    async putUnsentForecast(unsentForecast){
        await db[ForecastingTables.UnsentForecasts].put(unsentForecast);
    },
    async removeUnsentForecast(cropLocationId, varietyId, forecastDate) {
        await db[ForecastingTables.UnsentForecasts]
            .delete([cropLocationId, varietyId, forecastDate]);
    },    
    async clearUnsentForecasts() {
        await db[ForecastingTables.UnsentForecasts].clear();
    },
    async removeUnsentCropVariety(cropLocationId, varietyId) {
        await db[ForecastingTables.UnsentCropVarieties]
            .delete([cropLocationId, varietyId]);
    },
    async putUnsentCropVariety(unsentVariety) {
        await db[ForecastingTables.UnsentCropVarieties].put(unsentVariety);
    },
    async getUnsentCropVarieties(cropLocationIds){
        let items = await db[ForecastingTables.UnsentCropVarieties]
            .where("cropLocationId").anyOf(cropLocationIds)
            .toArray();
        return items;
    },
    async getUnsentCropVariety(cropLocationId, varietyId){
        return await db[ForecastingTables.UnsentCropVarieties]
            .where({ cropLocationId, varietyId })
            .first();
    },
    async getAllUnsentCropVarieties() {
        return await db[ForecastingTables.UnsentCropVarieties]
            .toArray();
    },
    async getCropVariety(cropLocationId, varietyId){
        return await db[ForecastingTables.Varieties]
            .where({ cropLocationId, varietyId })
            .first();
    },
    async countUnsentCropVarieties() {
        return await db[ForecastingTables.UnsentCropVarieties]
            .count();
    },    
    async getUnsentNotes(cropLocationIds){
        let items = await db[ForecastingTables.UnsyncedNotes]
            .where("cropLocationId").anyOf(cropLocationIds)
            .toArray();
        return items;
    },
    async getNotes(cropLocationIds) {
        return await db[ForecastingTables.Notes]
        .where("cropLocationId").anyOf(cropLocationIds)
        .toArray();
    },
    async getNote(cropLocationId, varietyId, raisedAt) {
        return await db[ForecastingTables.Notes]
        .where({ cropLocationId, varietyId, raisedAt })
        .first();
    },
    async putNotes(notes){
        await db[ForecastingTables.Notes].bulkPut(notes);
    },
    async putNote(note) {
        await db[ForecastingTables.Notes].put(note);
    },
    async clearNotes() {
        await db[ForecastingTables.Notes].clear();
    },
    async countUnsyncedNotes(){
        return await db[ForecastingTables.UnsyncedNotes]
            .count();
    },
    async getAllUnsyncedNotes(){
        return await db[ForecastingTables.UnsyncedNotes]
            .toArray();
    },
    async getUnsyncedNotes(cropLocationIds){
        let items = await db[ForecastingTables.UnsyncedNotes]
            .where("cropLocationId").anyOf(cropLocationIds)
            .toArray();
        return items;
    },
    async getUnsyncedNote(cropLocationId, varietyId, raisedAt) {
        return await db[ForecastingTables.UnsyncedNotes]
            .where({ cropLocationId, varietyId, raisedAt })
            .first();
    },
    async putUnsyncedNote(UnsyncedNote){
        await db[ForecastingTables.UnsyncedNotes].put(UnsyncedNote);
    },
    async removeUnsyncedNote(cropLocationId, varietyId, raisedAt) {
        await db[ForecastingTables.UnsyncedNotes]
            .delete([cropLocationId, varietyId, raisedAt]);
    },
    async clearUnsyncedNotes() {
        await db[ForecastingTables.UnsyncedNotes].clear();
    },
    async clearNoteAlertCategoriesData() {
        await db[ForecastingTables.NoteAlertCategories].clear();
    },
    async putNoteAlertCategoriesData(noteAlertCategories) {
        await db[ForecastingTables.NoteAlertCategories].bulkPut(noteAlertCategories);
    }
}